const MAX_WEBSOCKET_FAILS = 7;
const MIN_WEBSOCKET_RETRY_TIME = 3000; // 3 sec
const MAX_WEBSOCKET_RETRY_TIME = 300000; // 5 mins
const MAX_WEBSOCKET_MISSED_HEARTBEATS = 3;
const WEBSOCKET_HEARTBEAT_MESSAGE = '--heartbeat--';
const WEBSOCKET_HEARTBEAT_MESSAGE_RESEND_TIME = 25000; // 25 sec

export class WebSocketClient {
    constructor() {
        this.connection = null;
        this.connectionUrl = null;
        this.connectionFailCount = 0;
        this.connectionMissedHeartbeatCount = 0;
        this.messageCallback = null;
    }

    initialize({ url: maybeUrl = null, token: maybeToken = null, channel: maybeModule = 'BROADCAST' } = {}) {
        if (this.connection) {
            return;
        }

        const url = maybeUrl || window.WEBSOCKET_URL;
        const token = maybeToken;
        const module = maybeModule;

        this.connectionUrl = url + module + '/' + token;
        this.connection = new WebSocket(this.connectionUrl);

        this.connection.onopen = () => {
            this.connectionFailCount = 0;
            this.connectionMissedHeartbeatCount = 0;

            this.runHeartbeat();
        };

        this.connection.onclose = () => {
            this.connection = null;
            this.connectionFailCount++;

            setTimeout(() => {
                this.initialize({ url, token, module });
            }, this.getRetryTime(this.connectionFailCount));
        };

        this.connection.onerror = () => {};

        this.connection.onmessage = (evt) => {
            if (evt.data === WEBSOCKET_HEARTBEAT_MESSAGE) {
                this.connectionMissedHeartbeatCount = 0;
                return;
            }

            const msg = JSON.parse(evt.data);
            if (this.messageCallback) {
                this.messageCallback(msg);
            }
        };
    }

    close() {
        this.connectionFailCount = 0;
        this.connectionMissedHeartbeatCount = 0;
        if (this.connection && this.connection.readyState === WebSocket.OPEN) {
            this.connection.onclose = () => {};
            this.connection.close();
            this.connection = null;
        }
    }

    setMessageCallback(callback) {
        this.messageCallback = callback;
    }

    runHeartbeat() {
        const heartbeatInterval = setInterval(() => {
            this.connectionMissedHeartbeatCount++;
            if (this.connectionMissedHeartbeatCount >= MAX_WEBSOCKET_MISSED_HEARTBEATS) {
                console.warn('Closing WebSocket connection. Reason: Too many missed heartbeats.');
                clearInterval(heartbeatInterval);
                this.close();
            }
            if (this.connection !== null) {
                this.connection.send(WEBSOCKET_HEARTBEAT_MESSAGE);
            }
        }, WEBSOCKET_HEARTBEAT_MESSAGE_RESEND_TIME);
    }

    getRetryTime(failCount) {
        let retryTime = MIN_WEBSOCKET_RETRY_TIME;

        // If we've failed a bunch of connections then start backing off
        if (failCount > MAX_WEBSOCKET_FAILS) {
            retryTime = MIN_WEBSOCKET_RETRY_TIME * failCount;
            if (retryTime > MAX_WEBSOCKET_RETRY_TIME) {
                retryTime = MAX_WEBSOCKET_RETRY_TIME;
            }
        }

        return retryTime;
    }
}
